// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* OrgSwitcher
   Pinned at the top of the sidebar, just under the Ultimo Bots logo.

   Geometry must match a \`.sidebar-label-container\` MuiListItem inside
   \`.menu-list\` exactly, so the workspace switcher's chevron lines up
   with the Bots / Connect / Resources chevrons:

   - \`.menu-list\` reserves a 12px gutter on the right
     (\`padding-right: 4px\` + \`scrollbar-gutter: stable\` ≈ 8px).
     \`.org-switcher\` is a sibling of \`.menu-list\`, so it mirrors that
     gutter via \`padding-right: 14px\` on the wrapper (a hair more to
     account for the actual rendered Webkit scrollbar width on
     Windows).
   - \`.MuiListItem-button\` inside menu-list is \`width: 90%; margin: 0
     auto\`. \`.org-switcher-trigger\` mirrors that.
   - \`.sidebar-label-container\` forces \`padding-left: 20px\` and the MUI
     ListItem default \`padding-right: 16px\`. The trigger uses the same
     \`8px 16px 8px 20px\` padding so its text and chevron sit at the
     same x-coordinates as the rows below.
   - The chevron uses MUI's default ExpandMore size (24px) so its right
     edge matches the menu rows' chevrons exactly. */

.org-switcher {
  position: relative;
  width: 100%;
  margin: 8px 0 12px 0;
  padding-right: 14px;
  box-sizing: border-box;
}

.org-switcher-trigger {
  display: flex;
  align-items: center;
  width: 90%;
  margin: 0 auto;
  background: transparent;
  border: 1px solid #bdbdbd;
  border-radius: 8px;
  color: #f8f8f8;
  box-sizing: border-box;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.org-switcher-trigger:hover,
.org-switcher-trigger:focus-within,
.org-switcher-trigger.open {
  background-color: var(--sidebar-hover-bg);
  border-color: #ffffff;
}

.org-switcher-label {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1 1;
  min-width: 0;
  padding: 8px 4px 8px 12px;
  background: transparent;
  border: none;
  color: inherit;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
}

.org-switcher-chev-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px 8px 4px;
  background: transparent;
  border: none;
  color: inherit;
  cursor: pointer;
  flex-shrink: 0;
}

.org-switcher-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: transparent;
  border: none;
  color: #fff;
  flex: 0 0 28px;
  font-size: 20px;
}

.org-switcher-text {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.org-switcher-name {
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.org-switcher-role {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.65);
  text-transform: capitalize;
  margin-top: 1px;
}

.org-switcher-chev {
  /* MUI's \`.MuiSvgIcon-fontSizeMedium\` already sets font-size: 1.5rem
     and width/height: 1em, so we just colour it and animate rotation. */
  color: #ffffff;
  transition: transform 0.25s ease;
  flex: 0 0 auto;
}

.org-switcher-trigger.open .org-switcher-chev {
  transform: rotate(180deg);
}

/* Dropdown ----------------------------------------------------------- */
.org-switcher-menu {
  position: absolute;
  top: calc(100% + 6px);
  /* Match the trigger's footprint exactly. The wrapper has
     \`padding-right: 14px\` (scrollbar gutter) and the trigger lives in
     the content box at \`width: 90%; margin: 0 auto\`. Absolute
     positioning is relative to the wrapper's padding box, so we need
     to offset the right side by that 14px gutter on top of the 5%
     centering inset. */
  left: 5%;
  right: calc(5% + 14px);
  background: #fff;
  color: #222;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18), 0 1px 4px rgba(0, 0, 0, 0.12);
  z-index: 1300;
  overflow: hidden;
  padding: 6px 0;
  max-height: 360px;
  overflow-y: auto;
}

.org-switcher-menu-header {
  padding: 6px 12px 4px 12px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: #888;
}

.org-switcher-empty {
  padding: 10px 12px;
  font-size: 13px;
  color: #888;
}

.org-switcher-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 8px 12px;
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: left;
  color: #222;
  font-size: 13px;
  font-family: inherit;
  transition: background 0.12s ease;
}

.org-switcher-item:hover:not(:disabled) {
  background: #f4f1fe;
}

.org-switcher-item:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.org-switcher-item.current {
  background: #f7f4ff;
}

.org-switcher-item.manage {
  color: #5616ea;
  font-weight: 500;
}

.org-switcher-item-check {
  width: 16px;
  display: inline-flex;
  justify-content: center;
  color: #5616ea;
  font-size: 12px;
  flex-shrink: 0;
}

.org-switcher-item-text {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.org-switcher-item-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.org-switcher-item-role {
  font-size: 10px;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin-top: 1px;
}

.org-switcher-divider {
  height: 1px;
  background: #eee;
  margin: 6px 0;
}

.org-switcher-error {
  margin: 6px 12px 8px 12px;
  padding: 6px 8px;
  background: #fde7e7;
  color: #b00020;
  border-radius: 6px;
  font-size: 12px;
}

/* ── Header variant (light bar, compact single-line trigger) ───────── */
.org-switcher.header {
  width: auto;
  margin: 0;
  padding-right: 0;
  min-width: 0;
}

.org-switcher.header .org-switcher-trigger {
  width: auto;
  margin: 0;
  max-width: 220px;
  background-color: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.16);
  color: #ffffff;
}

.org-switcher.header .org-switcher-trigger:hover,
.org-switcher.header .org-switcher-trigger:focus-within,
.org-switcher.header .org-switcher-trigger.open {
  background-color: rgba(255, 255, 255, 0.16);
  border-color: rgba(255, 255, 255, 0.28);
}

.org-switcher.header .org-switcher-label {
  padding: 6px 4px 6px 10px;
  gap: 8px;
}

.org-switcher.header .org-switcher-chev-btn {
  padding: 6px 10px 6px 4px;
}

.org-switcher.header .org-switcher-icon {
  width: auto;
  height: auto;
  font-size: 14px;
  color: #ffffff;
  flex: 0 0 auto;
}

.org-switcher.header .org-switcher-role {
  display: none;
}

.org-switcher.header .org-switcher-name {
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
}

.org-switcher.header .org-switcher-chev {
  color: rgba(255, 255, 255, 0.8);
}

.org-switcher.header .org-switcher-menu {
  left: 0;
  right: auto;
  min-width: 240px;
}
`, "",{"version":3,"sources":["webpack://./src/components/OrgSwitcher.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;oDAoBoD;;AAEpD;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,8DAA8D;AAChE;;AAEA;;;EAGE,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE;wEACsE;EACtE,cAAc;EACd,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yEAAyE;AACzE;EACE,kBAAkB;EAClB,qBAAqB;EACrB;;;;;uBAKqB;EACrB,QAAQ;EACR,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,yEAAyE;EACzE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA,yEAAyE;AACzE;EACE,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,2CAA2C;EAC3C,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;;;EAGE,2CAA2C;EAC3C,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,OAAO;EACP,WAAW;EACX,gBAAgB;AAClB","sourcesContent":["/* OrgSwitcher\r\n   Pinned at the top of the sidebar, just under the Ultimo Bots logo.\r\n\r\n   Geometry must match a `.sidebar-label-container` MuiListItem inside\r\n   `.menu-list` exactly, so the workspace switcher's chevron lines up\r\n   with the Bots / Connect / Resources chevrons:\r\n\r\n   - `.menu-list` reserves a 12px gutter on the right\r\n     (`padding-right: 4px` + `scrollbar-gutter: stable` ≈ 8px).\r\n     `.org-switcher` is a sibling of `.menu-list`, so it mirrors that\r\n     gutter via `padding-right: 14px` on the wrapper (a hair more to\r\n     account for the actual rendered Webkit scrollbar width on\r\n     Windows).\r\n   - `.MuiListItem-button` inside menu-list is `width: 90%; margin: 0\r\n     auto`. `.org-switcher-trigger` mirrors that.\r\n   - `.sidebar-label-container` forces `padding-left: 20px` and the MUI\r\n     ListItem default `padding-right: 16px`. The trigger uses the same\r\n     `8px 16px 8px 20px` padding so its text and chevron sit at the\r\n     same x-coordinates as the rows below.\r\n   - The chevron uses MUI's default ExpandMore size (24px) so its right\r\n     edge matches the menu rows' chevrons exactly. */\r\n\r\n.org-switcher {\r\n  position: relative;\r\n  width: 100%;\r\n  margin: 8px 0 12px 0;\r\n  padding-right: 14px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.org-switcher-trigger {\r\n  display: flex;\r\n  align-items: center;\r\n  width: 90%;\r\n  margin: 0 auto;\r\n  background: transparent;\r\n  border: 1px solid #bdbdbd;\r\n  border-radius: 8px;\r\n  color: #f8f8f8;\r\n  box-sizing: border-box;\r\n  transition: background-color 0.2s ease, border-color 0.2s ease;\r\n}\r\n\r\n.org-switcher-trigger:hover,\r\n.org-switcher-trigger:focus-within,\r\n.org-switcher-trigger.open {\r\n  background-color: var(--sidebar-hover-bg);\r\n  border-color: #ffffff;\r\n}\r\n\r\n.org-switcher-label {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  flex: 1;\r\n  min-width: 0;\r\n  padding: 8px 4px 8px 12px;\r\n  background: transparent;\r\n  border: none;\r\n  color: inherit;\r\n  cursor: pointer;\r\n  text-align: left;\r\n  font-family: inherit;\r\n}\r\n\r\n.org-switcher-chev-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 8px 12px 8px 4px;\r\n  background: transparent;\r\n  border: none;\r\n  color: inherit;\r\n  cursor: pointer;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.org-switcher-icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 28px;\r\n  height: 28px;\r\n  background: transparent;\r\n  border: none;\r\n  color: #fff;\r\n  flex: 0 0 28px;\r\n  font-size: 20px;\r\n}\r\n\r\n.org-switcher-text {\r\n  flex: 1 1 auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n}\r\n\r\n.org-switcher-name {\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: #fff;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.org-switcher-role {\r\n  font-size: 11px;\r\n  color: rgba(255, 255, 255, 0.65);\r\n  text-transform: capitalize;\r\n  margin-top: 1px;\r\n}\r\n\r\n.org-switcher-chev {\r\n  /* MUI's `.MuiSvgIcon-fontSizeMedium` already sets font-size: 1.5rem\r\n     and width/height: 1em, so we just colour it and animate rotation. */\r\n  color: #ffffff;\r\n  transition: transform 0.25s ease;\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.org-switcher-trigger.open .org-switcher-chev {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n/* Dropdown ----------------------------------------------------------- */\r\n.org-switcher-menu {\r\n  position: absolute;\r\n  top: calc(100% + 6px);\r\n  /* Match the trigger's footprint exactly. The wrapper has\r\n     `padding-right: 14px` (scrollbar gutter) and the trigger lives in\r\n     the content box at `width: 90%; margin: 0 auto`. Absolute\r\n     positioning is relative to the wrapper's padding box, so we need\r\n     to offset the right side by that 14px gutter on top of the 5%\r\n     centering inset. */\r\n  left: 5%;\r\n  right: calc(5% + 14px);\r\n  background: #fff;\r\n  color: #222;\r\n  border-radius: 8px;\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18), 0 1px 4px rgba(0, 0, 0, 0.12);\r\n  z-index: 1300;\r\n  overflow: hidden;\r\n  padding: 6px 0;\r\n  max-height: 360px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.org-switcher-menu-header {\r\n  padding: 6px 12px 4px 12px;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  letter-spacing: 0.4px;\r\n  text-transform: uppercase;\r\n  color: #888;\r\n}\r\n\r\n.org-switcher-empty {\r\n  padding: 10px 12px;\r\n  font-size: 13px;\r\n  color: #888;\r\n}\r\n\r\n.org-switcher-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  width: 100%;\r\n  padding: 8px 12px;\r\n  background: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n  text-align: left;\r\n  color: #222;\r\n  font-size: 13px;\r\n  font-family: inherit;\r\n  transition: background 0.12s ease;\r\n}\r\n\r\n.org-switcher-item:hover:not(:disabled) {\r\n  background: #f4f1fe;\r\n}\r\n\r\n.org-switcher-item:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.org-switcher-item.current {\r\n  background: #f7f4ff;\r\n}\r\n\r\n.org-switcher-item.manage {\r\n  color: #5616ea;\r\n  font-weight: 500;\r\n}\r\n\r\n.org-switcher-item-check {\r\n  width: 16px;\r\n  display: inline-flex;\r\n  justify-content: center;\r\n  color: #5616ea;\r\n  font-size: 12px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.org-switcher-item-text {\r\n  flex: 1 1 auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n}\r\n\r\n.org-switcher-item-name {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.org-switcher-item-role {\r\n  font-size: 10px;\r\n  color: #888;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.4px;\r\n  margin-top: 1px;\r\n}\r\n\r\n.org-switcher-divider {\r\n  height: 1px;\r\n  background: #eee;\r\n  margin: 6px 0;\r\n}\r\n\r\n.org-switcher-error {\r\n  margin: 6px 12px 8px 12px;\r\n  padding: 6px 8px;\r\n  background: #fde7e7;\r\n  color: #b00020;\r\n  border-radius: 6px;\r\n  font-size: 12px;\r\n}\r\n\r\n/* ── Header variant (light bar, compact single-line trigger) ───────── */\r\n.org-switcher.header {\r\n  width: auto;\r\n  margin: 0;\r\n  padding-right: 0;\r\n  min-width: 0;\r\n}\r\n\r\n.org-switcher.header .org-switcher-trigger {\r\n  width: auto;\r\n  margin: 0;\r\n  max-width: 220px;\r\n  background-color: rgba(255, 255, 255, 0.07);\r\n  border: 1px solid rgba(255, 255, 255, 0.16);\r\n  color: #ffffff;\r\n}\r\n\r\n.org-switcher.header .org-switcher-trigger:hover,\r\n.org-switcher.header .org-switcher-trigger:focus-within,\r\n.org-switcher.header .org-switcher-trigger.open {\r\n  background-color: rgba(255, 255, 255, 0.16);\r\n  border-color: rgba(255, 255, 255, 0.28);\r\n}\r\n\r\n.org-switcher.header .org-switcher-label {\r\n  padding: 6px 4px 6px 10px;\r\n  gap: 8px;\r\n}\r\n\r\n.org-switcher.header .org-switcher-chev-btn {\r\n  padding: 6px 10px 6px 4px;\r\n}\r\n\r\n.org-switcher.header .org-switcher-icon {\r\n  width: auto;\r\n  height: auto;\r\n  font-size: 14px;\r\n  color: #ffffff;\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.org-switcher.header .org-switcher-role {\r\n  display: none;\r\n}\r\n\r\n.org-switcher.header .org-switcher-name {\r\n  color: #ffffff;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n\r\n.org-switcher.header .org-switcher-chev {\r\n  color: rgba(255, 255, 255, 0.8);\r\n}\r\n\r\n.org-switcher.header .org-switcher-menu {\r\n  left: 0;\r\n  right: auto;\r\n  min-width: 240px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
